import React from "react";

interface IAppointmentPhasePickerProps {
  value: server.dto.AppointmentPhases
  onChange: (value: server.dto.AppointmentPhases) => void
}

class AppointmentPhasePicker extends React.Component<IAppointmentPhasePickerProps> {
  public render(): JSX.Element {
    const { onChange, value } = this.props;

    return (
      <div className="inline-flex pickerlist">
        {serverReference.appointmentPhases.map((phase: server.dto.AppointmentPhase) => <div
          key={phase.value}
          onClick={() => {
            onChange(phase.value);
          }}
          className={`margin-right flex ${(phase.value === value) ? "active" : ""}`}>
          <div style={{ width: 23 }}>
            <i className={phase.icon} />
          </div>
          <span>{phase.text}</span>
        </div>)
        }
      </div>
    );
  }
}

export default AppointmentPhasePicker;
